module.exports = __webpack_public_path__ + "static/assets/ce0bff212850f9adab3d7dfb25be8147.svg";